<template>
  <div>
    <label class="col-form-label col-sm-4" v-if="label">{{ label }}</label>
    <div :class="{ 'col-sm-8': !!label }">
      <div class="input-group">
        <input
          class="form-control"
          type="date"
          :value="modelValue"
          :disabled="disabled"
          @change="$emit('update:modelValue', $event.target.value)"
        />
        <div class="input-group-append ms-3" v-show="withClear">
          <button class="btn btn-outline-warning" type="button" @click="$emit('update:modelValue', '')">
            Izbriši datum
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// moved verbatim out of views/DeviceEdit.js, where it was a second component object in the same
// file (the options API, so it stays one)
export default {
  name: "DateOnly",
  props: {
    label: { type: String, required: false },
    withClear: { type: Boolean, default: true },
    disabled: { type: Boolean, default: false },
    modelValue: { type: String },
    emits: ["update:modelValue"],
  },
}
</script>
